import { render, staticRenderFns } from "./InterestCheckboxes.vue?vue&type=template&id=fabf7af2&scoped=true&"
import script from "./InterestCheckboxes.vue?vue&type=script&lang=js&"
export * from "./InterestCheckboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabf7af2",
  null
  
)

export default component.exports